import { render, staticRenderFns } from "./automatedAssessmentReport.vue?vue&type=template&id=494a8579&scoped=true"
import script from "./automatedAssessmentReport.vue?vue&type=script&lang=js"
export * from "./automatedAssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./automatedAssessmentReport.vue?vue&type=style&index=0&id=494a8579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a8579",
  null
  
)

export default component.exports